import React, { FC } from 'react'
import SidePanelMenu from '@bt-react/components/SidePanelMenu'
import { PresenterSidePanelMenuProps } from './types'
import { SidePanelTypes } from '@bt-react/constants'
import SidePanelQuestionsButton from './containers/SidePanelQuestionsButton'
import SidePanelChatButton from './containers/SidePanelChatButton'
import SidePanelAnnouncementsButton from './containers/SidePanelAnnouncementsButton'
import SidePanelDetailsButton from './containers/SidePanelDetailsButton'
import SidePanelParticipantsButton from './containers/SidePanelParticipantsButton'
import SidePanelSessionStatusButton from './containers/SidePanelSessionStatusButton'
import SidePanelFeatureFlagsButton from './containers/SidePanelFeatureFlagsButton'
import SidePanelVotesButton from './containers/SidePanelVotesButton'
import SidePanelAttachmentsButton from './containers/SidePanelAttachmentsButton'

const PresenterSidePanelMenu: FC<PresenterSidePanelMenuProps> = (
  { isSidePanelOpen,
    closeSidePanel,
    openSidePanel,
    setSelectedMenuItem,
    featureFlags,
    debug }) => {

  return <SidePanelMenu
    isOpen={isSidePanelOpen}
    onMenuOpen={isSidePanelOpen ? closeSidePanel : openSidePanel}
    setSelectedMenuItem={setSelectedMenuItem}
  >
    { featureFlags.questions && <SidePanelQuestionsButton panel={SidePanelTypes.QUESTIONS} /> }
    { featureFlags.votes && <SidePanelVotesButton panel={SidePanelTypes.VOTES} /> }
    { featureFlags.announcements && <SidePanelAnnouncementsButton panel={SidePanelTypes.ANNOUNCEMENTS} /> }
    { featureFlags.attachments && <SidePanelAttachmentsButton panel={SidePanelTypes.ATTACHMENTS} /> }
    <SidePanelDetailsButton panel={SidePanelTypes.DETAILS} />
    <SidePanelParticipantsButton panel={SidePanelTypes.PARTICIPANTS} />
    <SidePanelChatButton panel={SidePanelTypes.CHAT} />

    { debug && <SidePanelFeatureFlagsButton panel={SidePanelTypes.FEATURE_FLAGS} /> }
    { debug && <SidePanelSessionStatusButton panel={SidePanelTypes.SESSION_STATUS} /> }
  </SidePanelMenu>

}

export default PresenterSidePanelMenu
